enum SchedulerControllerMouseState {
  Default = "Default",
  DragSchedule = "DragSchedule",
  DragTopOfSchedule = "DragTopOfSchedule",
  DragBottomOfSchedule = "DragBottomOfSchedule",
}

export default SchedulerControllerMouseState;
